/**
 * UGC / Testimonials Section — Carousel functionality
 */
(function () {
  'use strict';

  var cleanupMap = new Map();
  var autoKey = 0;

  function getKey(el) {
    return el.id || (el.dataset.ugcKey = el.dataset.ugcKey || '__ugc_' + (autoKey++));
  }

  var SOUND_ON_SVG =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M11 5L6 9H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3l5 4V5Z" fill="currentColor"/>' +
    '<path d="M16 9a4 4 0 0 1 0 6M19 6a8 8 0 0 1 0 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '</svg>';
  var SOUND_OFF_SVG =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M11 5L6 9H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3l5 4V5Z" fill="currentColor"/>' +
    '<path d="M16 10l5 5M21 10l-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '</svg>';

  function buildSoundToggle(video) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'oddit-section-ugc__sound-toggle';
    function render() {
      btn.innerHTML = video.muted ? SOUND_OFF_SVG : SOUND_ON_SVG;
      btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      btn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      if (!video.muted && video.paused) {
        video.play().catch(function () {});
      }
      render();
    });
    video.addEventListener('volumechange', render);
    render();
    return btn;
  }

  function initUGCSection(sectionEl) {
    if (!sectionEl) {
      document.querySelectorAll('.oddit-section-ugc').forEach(function (el) {
        initUGCSection(el);
      });
      return;
    }
    var section = sectionEl;
    var key = getKey(section);

    if (cleanupMap.has(key)) {
      cleanupMap.get(key)();
      cleanupMap.delete(key);
    }

    var track = section.querySelector('.oddit-section-ugc__track');
    var slides = section.querySelectorAll('.oddit-section-ugc__slide');
    var prevBtn = section.querySelector('.oddit-section-ugc__nav-btn--prev');
    var nextBtn = section.querySelector('.oddit-section-ugc__nav-btn--next');
    var indicators = section.querySelectorAll('.oddit-section-ugc__indicator');
    var indicatorsContainer = section.querySelector('.oddit-section-ugc__indicators');

    if (!track || slides.length === 0) return;

    var currentIndex = 0;
    var slidesPerView = 1;
    var slideGap = 8;

    function getSettings() {
      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      if (isDesktop) {
        slideGap = 16;
        var containerWidth = track.parentElement.offsetWidth;
        var slideWidth = 620;
        slidesPerView = Math.floor((containerWidth + slideGap) / (slideWidth + slideGap));
        slidesPerView = Math.max(1, Math.min(slidesPerView, slides.length));
      } else {
        slideGap = 8;
        slidesPerView = 1;
      }
    }

    function getSlideWidth() {
      if (slides.length === 0) return 0;
      return slides[0].offsetWidth;
    }

    function getMaxIndex() {
      return Math.max(0, slides.length - slidesPerView);
    }

    function updateTrack() {
      var slideWidth = getSlideWidth();
      var offset = currentIndex * (slideWidth + slideGap);
      track.style.transform = 'translateX(-' + offset + 'px)';
    }

    function updateIndicators() {
      indicators.forEach(function (indicator, index) {
        if (index === currentIndex) {
          indicator.classList.add('oddit-section-ugc__indicator--active');
        } else {
          indicator.classList.remove('oddit-section-ugc__indicator--active');
        }
      });
    }

    function goToSlide(index) {
      var maxIndex = getMaxIndex();
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      updateTrack();
      updateIndicators();
    }

    function goNext() {
      var maxIndex = getMaxIndex();
      if (currentIndex < maxIndex) {
        goToSlide(currentIndex + 1);
      } else {
        goToSlide(0);
      }
    }

    function goPrev() {
      if (currentIndex > 0) {
        goToSlide(currentIndex - 1);
      } else {
        goToSlide(getMaxIndex());
      }
    }

    // Event Listeners
    function onPrevClick() { goPrev(); }
    function onNextClick() { goNext(); }

    if (prevBtn) {
      prevBtn.addEventListener('click', onPrevClick);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', onNextClick);
    }

    // Indicator clicks via event delegation
    function onIndicatorClick(e) {
      var btn = e.target.closest('.oddit-section-ugc__indicator');
      if (!btn) return;
      var index = Array.prototype.indexOf.call(indicators, btn);
      if (index !== -1) {
        goToSlide(index);
      }
    }

    if (indicatorsContainer) {
      indicatorsContainer.addEventListener('click', onIndicatorClick);
    }

    // Drag-to-slide support (mouse + touch via Pointer Events)
    var carousel = section.querySelector('.oddit-section-ugc__carousel');
    var dragStartX = 0;
    var dragStartY = 0;
    var dragStartOffset = 0;
    var isDragging = false;
    var activePointerId = null;
    var dragDirection = null; // null | 'horizontal' | 'vertical'

    function getBaseOffset() {
      var slideWidth = getSlideWidth();
      return currentIndex * (slideWidth + slideGap);
    }

    function applyDragTransform(dragDelta) {
      var baseOffset = getBaseOffset();
      var slideWidth = getSlideWidth();
      var maxOffset = (slides.length - 1) * (slideWidth + slideGap);
      var minOffset = 0;
      var newOffset = baseOffset - dragDelta;
      var clampedOffset = Math.max(minOffset, Math.min(maxOffset, newOffset));
      track.style.transition = 'none';
      track.style.transform = 'translateX(-' + clampedOffset + 'px)';
    }

    function snapToNearestSlide(dragDelta) {
      track.style.transition = '';
      var slideWidth = getSlideWidth();
      var threshold = (slideWidth + slideGap) * 0.25;
      var targetIndex = currentIndex;
      if (dragDelta > threshold) {
        targetIndex = Math.max(0, currentIndex - 1);
      } else if (dragDelta < -threshold) {
        targetIndex = Math.min(getMaxIndex(), currentIndex + 1);
      }
      goToSlide(targetIndex);
    }

    function onPointerDown(e) {
      if (e.button !== 0 && e.button !== undefined) return;
      if (activePointerId != null) return;
      var target = e.target.closest('a, button');
      if (target && target !== e.currentTarget) return;

      /* Mouse only: blocks native image drag without interfering with touch scroll (PT-212). */
      if (e.pointerType === 'mouse') {
        e.preventDefault();
      }

      activePointerId = e.pointerId;
      isDragging = true;
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      dragStartOffset = getBaseOffset();
      dragDirection = null;
      track.style.userSelect = 'none';
      // Do NOT set pointer capture yet — wait until direction is determined
    }

    function onPointerMove(e) {
      if (!isDragging || e.pointerId !== activePointerId) return;
      var dx = e.clientX - dragStartX;
      var dy = e.clientY - dragStartY;

      // Determine drag direction on first significant movement
      if (dragDirection === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
        if (Math.abs(dy) > Math.abs(dx)) {
          // Vertical — cancel horizontal drag and let page scroll
          isDragging = false;
          activePointerId = null;
          dragDirection = 'vertical';
          track.style.userSelect = '';
          track.style.transition = '';
          goToSlide(currentIndex);
          return;
        } else {
          dragDirection = 'horizontal';
          if (carousel) carousel.style.cursor = 'grabbing';
          // Now capture pointer to ensure we get all move/up events
          track.setPointerCapture && track.setPointerCapture(e.pointerId);
        }
      }

      if (dragDirection !== 'horizontal') return;
      applyDragTransform(dx);
    }

    var didDrag = false;

    function onPointerUp(e) {
      if (!isDragging || e.pointerId !== activePointerId) return;
      var dragDelta = e.clientX - dragStartX;
      didDrag = dragDirection === 'horizontal' && Math.abs(dragDelta) > 5;
      isDragging = false;
      activePointerId = null;
      dragDirection = null;
      if (carousel) carousel.style.cursor = '';
      track.style.userSelect = '';
      track.releasePointerCapture && track.releasePointerCapture(e.pointerId);
      snapToNearestSlide(dragDelta);
      setTimeout(function () { didDrag = false; }, 0);
    }

    function onPointerCancel(e) {
      if (e.pointerId === activePointerId) {
        isDragging = false;
        activePointerId = null;
        dragDirection = null;
        if (carousel) carousel.style.cursor = '';
        track.style.userSelect = '';
        track.style.transition = '';
        goToSlide(currentIndex);
      }
    }

    function onTouchMove(e) {
      // Only block native scroll when we've confirmed a horizontal drag
      if (isDragging && dragDirection === 'horizontal' && e.touches.length === 1) {
        e.preventDefault();
      }
    }

    function onCarouselClick(e) {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    function onCarouselDragStart(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    var dragTarget = carousel || track;
    if (dragTarget) {
      section.querySelectorAll('.oddit-section-ugc__carousel img').forEach(function (img) {
        img.setAttribute('draggable', 'false');
      });
      dragTarget.addEventListener('dragstart', onCarouselDragStart, true);
    }
    dragTarget.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerUp);
    document.addEventListener('pointercancel', onPointerCancel);
    dragTarget.addEventListener('touchmove', onTouchMove, { passive: false });
    dragTarget.addEventListener('click', onCarouselClick, true);

    /* Video playback */
    var playBtns = section.querySelectorAll('.oddit-section-ugc__play-btn');
    var playCleanups = [];

    function preconnectHint(origin) {
      if (document.querySelector('link[rel="preconnect"][href="' + origin + '"]')) return;
      var link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = origin;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    }

    playBtns.forEach(function (btn) {
      function onPointerEnter() {
        var url = btn.getAttribute('data-video-url');
        if (!url) return;
        if (/youtube\.com|youtu\.be/.test(url)) {
          preconnectHint('https://www.youtube.com');
        } else if (/vimeo\.com/.test(url)) {
          preconnectHint('https://player.vimeo.com');
        }
      }

      btn.addEventListener('pointerenter', onPointerEnter);
      playCleanups.push(function () { btn.removeEventListener('pointerenter', onPointerEnter); });

      function onPlayClick() {
        var videoWrap = btn.closest('.oddit-section-ugc__video');
        if (!videoWrap || videoWrap.classList.contains('oddit-section-ugc__video--playing')) return;

        var videoUrl = btn.getAttribute('data-video-url');
        var videoType = btn.getAttribute('data-video-type') || 'external';
        if (!videoUrl || !window.OdditVideoEmbed) return;

        var overlayStyle = 'position:absolute;inset:0;width:100%;height:100%;z-index:2;';
        var player = window.OdditVideoEmbed.createPlayer(videoUrl, videoType, {
          videoStyle: overlayStyle + 'object-fit:cover;',
          iframeStyle: overlayStyle + 'border:none;',
          muted: false,
        });
        if (!player) return;

        videoWrap.classList.add('oddit-section-ugc__video--playing');
        videoWrap.style.position = 'relative';
        videoWrap.appendChild(player);
        btn.style.display = 'none';

        if (player.tagName === 'VIDEO') {
          var soundBtn = buildSoundToggle(player);
          videoWrap.appendChild(soundBtn);
          playCleanups.push(function () { soundBtn.remove(); });
        }
      }

      btn.addEventListener('click', onPlayClick);
      playCleanups.push(function () { btn.removeEventListener('click', onPlayClick); });
    });

    // Recalculate on resize (debounced)
    var resizeTimer;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        getSettings();
        goToSlide(Math.min(currentIndex, getMaxIndex()));
      }, 150);
    }

    window.addEventListener('resize', onResize);

    // Initialize
    getSettings();
    updateTrack();
    updateIndicators();

    cleanupMap.set(key, function () {
      if (prevBtn) prevBtn.removeEventListener('click', onPrevClick);
      if (nextBtn) nextBtn.removeEventListener('click', onNextClick);
      if (indicatorsContainer) indicatorsContainer.removeEventListener('click', onIndicatorClick);
      var dt = carousel || track;
      if (dt) {
        dt.removeEventListener('pointerdown', onPointerDown);
        dt.removeEventListener('dragstart', onCarouselDragStart, true);
        dt.removeEventListener('touchmove', onTouchMove);
        dt.removeEventListener('click', onCarouselClick, true);
      }
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
      document.removeEventListener('pointercancel', onPointerCancel);
      window.removeEventListener('resize', onResize);
      clearTimeout(resizeTimer);
      playCleanups.forEach(function (fn) { fn(); });
    });
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initUGCSection();
    });
  } else {
    initUGCSection();
  }

  // Theme editor: re-initialize on section load
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.oddit-section-ugc');
    if (section) {
      initUGCSection(section);
    }
  });

  // Theme editor: clean up on section unload
  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.oddit-section-ugc');
    if (section) {
      var key = getKey(section);
      if (cleanupMap.has(key)) {
        cleanupMap.get(key)();
        cleanupMap.delete(key);
      }
    }
  });
})();